import {makeReactContext} from 'lib/makeReactContext';
import {
  CustomMappingData,
  TaskDefinitionVersionSpecWithTaskSchemaFlowchart,
  TransitionSource,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {TaskDefinitionVersionSpecWithTaskSchema} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {FlowchartOptions} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorUtils';
import {FlowchartChangeGenerator} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processInteractiveFlowchartChanges';
import {ConfigurableTaskDefinitionGQL} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/useAllSchemasById';

import {NodeSidepanelBaseData} from './nodeUtils';

export interface NodeDetailsSidepanelContextValue extends NodeSidepanelBaseData {
  transitionSourceByNodeIdPair: Record<string, TransitionSource>;
  onChangeTransitionSource: (edgeId: string, newTransitionSource: TransitionSource) => void;
  applyFlowchartChanges: (changeGenerator: FlowchartChangeGenerator) => void;
  customMappingDataByEdgeId: Record<string, CustomMappingData>;
  onChangeCustomMappingData: (edgeId: string, newCustomMappingData: CustomMappingData) => void;
  onUpdateTaskDefinitionVersion: (
    updater: (
      currentFlowchart: TaskDefinitionVersionSpecWithTaskSchemaFlowchart
    ) => TaskDefinitionVersionSpecWithTaskSchema<unknown>,
    isBlocking: boolean
  ) => void;
  refetchFlowchartConfig?: () => void;
  interactiveFlowchartOptions: FlowchartOptions;
  didInitialConfigHaveConditionalMapping: boolean;
  didInitialFlowchartHaveChainedRouters: boolean;
  taskDefinitionsForSidepanel: Array<ConfigurableTaskDefinitionGQL>;
}

/** Context to provide node details sidepanel content with shared data and callbacks
 *
 * This contains all workflows-specific content that an application team wouldn't need to build
 * their sidepanels. If they do end up needing some of this content, they can use the context to access.
 */
export const NodeDetailsSidepanelContext = makeReactContext<NodeDetailsSidepanelContextValue>(() => {
  throw new Error('NodeDetailsSidepanelContext must be used within a provider');
}, 'NodeDetailsSidepanelContext');
